import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import Datatable from "../../Constants/Datatable";
import { PENCIL } from "../../Constants/SrcImages";
import { COLUMNS_ADMIN_PASSWORD } from "../../Constants/DatatableColumns";
import { Row, Col, Container, Button, Label } from "reactstrap";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";
import { AdminEditPassword } from "./../../Constants/Modal";
import {validateTokenStorage} from './../../Constants/Util';
import { getPassword, putPassword } from "../../Constants/Services";
import { IPassword } from "./../../Constants/Interfaces";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface IPasswordState {
  dataPasword: IPassword[];
  dataPaswordSelected: IPassword;
  loading: boolean;
  isOpenModalPasword: boolean;
}

class Password extends Component<RouteComponentProps<{}>, IPasswordState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataPasword: [],
      dataPaswordSelected: {
        per_id: "",
        per_cedula: "",
        per_name: "",
        per_lastname: "",
        per_password: "",
      },
      loading: false,
      isOpenModalPasword: false,
    };

    this.fetchPassword = this.fetchPassword.bind(this);
    this.handlerPutPassword = this.handlerPutPassword.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.rechargeDataPassword = this.rechargeDataPassword.bind(this);
    this.handleModalEditPassword = this.handleModalEditPassword.bind(this);
    this.isOpenModalEditPassword = this.isOpenModalEditPassword.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
  }

  async fetchPassword() {
    const response = await getPassword();
    this.setState({
      dataPasword: response,
      loading: false,
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchPassword();
  }

  handlerPutPassword() {
    const props = this.state.dataPaswordSelected;
    const body = {
      per_id: props.per_id,
      per_password: props.per_password,
    };

    putPassword(body);
    this.setState({ isOpenModalPasword: false, loading: true });

    setTimeout(() => {
      this.fetchPassword();
    }, 1000);
  }

  onChangePassword(e: any) {
    this.setState({
      dataPaswordSelected: {
        ...this.state.dataPaswordSelected,
        [e.target.name]: e.target.value,
      },
    });
  }

  rechargeDataPassword() {
    this.setState({ loading: true });

    setTimeout(() => {
      this.fetchPassword();
    }, 1000);
  }

  isOpenModalEditPassword() {
    this.setState((prevState) => ({
      isOpenModalPasword: !prevState.isOpenModalPasword,
    }));
  }

  handleModalEditPassword(row: IPassword) {
    this.setState((prevState) => ({
      isOpenModalPasword: !prevState.isOpenModalPasword,
      dataPaswordSelected: row,
    }));
  }

  colummPassword = (cell: any, row: IPassword) => (
    <Col xs={12} className="d-flex">
      <Label className="txt-underline" onClick={() => this.handleModalEditPassword(row)}>
        {row.per_id}
      </Label>
      <img className="img-status img-search" onClick={() => this.handleModalEditPassword(row)} src={PENCIL} alt="" />
    </Col>
  );

  rechargeData() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchPassword();
    }, 1000);
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalPasword && (
          <AdminEditPassword
            data={props.dataPaswordSelected}
            isOpen={props.isOpenModalPasword}
            toggle={this.isOpenModalEditPassword}
            toggleSave={this.handlerPutPassword}
            onChange={this.onChangePassword}
          />
        )}

        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row className="body-margin">
                <Col sm={12} className="text-center">
                  <h3>Contraseñas</h3>
                </Col>
                <Col sm={12} className="text-right">
                  <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loading} />
                  <Button color="primary" className="mr-2" onClick={() => this.rechargeData()}>
                    Recargar
                  </Button>
                </Col>
                <Col sm={12}>
                  <Datatable
                    data={props.dataPasword}
                    columns={COLUMNS_ADMIN_PASSWORD(this.colummPassword)}
                    keyProp="per_id"
                    exportD={false}
                    searchs={true}
                    selectRows={false}
                    optionSelectRow={null}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Password;
